import  { useState, useEffect, useRef } from "react";
import {  FiChevronLeft, FiChevronRight } from "react-icons/fi";

// --- 1. HARDCODED BANNER DATA ---
// Update 'id' to match exactly what is in your Firebase Category IDs
// Update 'src' to your local asset paths
const CATEGORY_BANNERS = [
  {
    id: "all", // Special ID for the default state
    src: "/assets/shop_page/all_honey_bg.jpg",
    title: "Mega Savings Festival",
    subtitle: "Up to 50% OFF on premium honey"
  },
  {
    
    id: "seasonal-honey", // Example Firebase Category ID
    src: "/assets/shop_page/seasonal12.jpg",
    title: "Wild Forest Honey",
    subtitle: "Pure nature in a jar"
  },
  {
    id: "bee-pollen",
    src: "/assets/shop_page/pollen124.jpg",
    title: "Acacia Honey",
    subtitle: "Smooth, light, and floral"
  },
     {
    id: "bees-wax",
    src: "/assets/shop_page/bee_wax_bg.png",
    title: "Bees Wax",
    subtitle: "Crystallized goodness"
  },
  {
    id: "herbal-honey",
    src: "/assets/shop_page/herbal_honey.jpg",
    title: "Herbal Honey",
    subtitle: "Crystallized goodness"
  },
   {
    id: "beekeeping",
    src: "/assets/shop_page/bee_keeping_bg.jpg",
    title: "Bee Keeping",
    subtitle: "Crystallized goodness"
  },
    {
    id: "multi-flower-honey",
    src: "/assets/shop_page/multi_f_honey.jpg",
    title: "Multi Flower Honey",
    subtitle: "Crystallized goodness"
  },
  
];

// --- 2. CUSTOM SLIDER COMPONENT ---
const HeroSlider = ({ selectedCategory }) => {
  // Find initial index based on selection, default to 0
  const getInitialIndex = () => {
    const idx = CATEGORY_BANNERS.findIndex((item) => item.id === selectedCategory);
    return idx >= 0 ? idx : 0;
  };

  const [currentIndex, setCurrentIndex] = useState(getInitialIndex());
  const timeoutRef = useRef(null);

  // Sync Slider when Selected Category changes externally
  useEffect(() => {
    const targetIndex = CATEGORY_BANNERS.findIndex((item) => item.id === selectedCategory);
    console.log(selectedCategory);
    if (targetIndex !== -1) {
      setCurrentIndex(targetIndex);
    } else if (selectedCategory === "all") {
      setCurrentIndex(0);
    }
  }, [selectedCategory]);

  // Auto-Slide Logic
  // Reset timer whenever currentIndex changes so the user has full time to read the new slide
  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === CATEGORY_BANNERS.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // 4 Seconds per slide

    return () => resetTimeout();
  }, [currentIndex]);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  // Manual Navigation
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === CATEGORY_BANNERS.length - 1 ? 0 : prev + 1));
  };
  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? CATEGORY_BANNERS.length - 1 : prev - 1));
  };

  return (
    <div className="relative w-full h-full overflow-hidden group">
      {/* SLIDING TRACK */}
      <div 
        className="flex transition-transform duration-700 ease-in-out h-full w-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {CATEGORY_BANNERS.map((banner, index) => (
          <div key={index} className="min-w-full h-full relative">
            {/* Image */}
            <img 
              src={banner.src} 
              alt={banner.title} 
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"} 
            />
            
            {/* Gradient Overlay & Text */}
            {/* <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/20 to-transparent flex items-center px-8 md:px-16">
              <div className="max-w-lg text-white">
                <h2 className="text-3xl md:text-5xl font-bold mb-2 drop-shadow-md transition-all duration-500 transform translate-y-0 opacity-100">
                  {banner.title}
                </h2>
                <p className="text-lg md:text-xl font-light opacity-90 drop-shadow-sm">
                  {banner.subtitle}
                </p>
              </div>
            </div> */}
          </div>
        ))}
      </div>

      {/* ARROWS (Visible on Hover) */}
      <button 
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/60 text-white p-3 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-sm"
      >
        <FiChevronLeft size={24} />
      </button>
      <button 
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/60 text-white p-3 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-sm"
      >
        <FiChevronRight size={24} />
      </button>

      {/* DOTS INDICATOR */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {CATEGORY_BANNERS.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              currentIndex === idx ? "bg-white w-6" : "bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  );
};


export default HeroSlider;